import { render, staticRenderFns } from "./TreatmentsStats.vue?vue&type=template&id=5bd586b8"
import script from "./TreatmentsStats.vue?vue&type=script&lang=js"
export * from "./TreatmentsStats.vue?vue&type=script&lang=js"
import style0 from "./TreatmentsStats.vue?vue&type=style&index=0&id=5bd586b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports